import { PageHeader } from "@/components/site/PageHeader";
import { TestLabSection } from "@/components/sections/TestLabSection";
import { IMAGES } from "@/lib/content";

export default function TestLab() {
  return (
    <>
      <PageHeader label="Coming Soon" title="THE FISH HOUSE TEST LAB" image={IMAGES.fishFocus}>
        A future expansion of the project — a two-stage, honest aquarium product testing platform. This page
        is a preview of what's coming, not a live feature.
      </PageHeader>
      <TestLabSection detailed />
    </>
  );
}
